'use strict';

var log = require('../../log/Log').channel('RoomPasswordController');
//var defaults = require('../../defaults/Defaults');
var sutl = require('../../sutl/Sutl');
var ShowPasswordExtension = require('./ShowPasswordExtension');
require('./ClockService');
require('./RemoteControlCodeController');
require('./RoomPasswordService');

angular.module('inara')
.controller('RoomPasswordController', RoomPasswordController);

RoomPasswordController.$inject = ['$scope', '$window', '$state',
    'RoomPasswordService', 'RoomService', 'RemoteControlService',
    'gettextCatalog', '$timeout', '$q', 'ClockService', 'ViewStateService',
    'ThemeService', '$document'];

function RoomPasswordController($scope, $window, $state,
    RoomPasswordService, RoomService, RemoteControlService,
    gettextCatalog, $timeout, $q, ClockService, ViewStateService,
    ThemeService, $document) {
    var vm = this;
    var passwordError = false;

    log.info('initializing');

    angular.extend(vm, new ShowPasswordExtension($timeout));
    $scope.$on('$stateChangeSuccess', onStateChange);
    vm.getFormattedTime = ClockService.getFormattedTime;
    vm.getLogoStyle = function() {
        var logoUrl = ThemeService.getImageUrl('logo');
        var style = {};
        if (logoUrl !== null && logoUrl !== '') {
            style['background-image'] = 'url(\'' + logoUrl + '\')';
        }
        return style;
    };
    vm.getPasswordError = function() {
        if (passwordError) {
            /// Error message for incorrect password
            return gettextCatalog.getString('Password incorrect');
        } else {
            return null;
        }
    };
    vm.getPasswordPlaceholder = function() {
        /// Placeholder for password field
        return gettextCatalog.getString('Password');
    };
    vm.getRoomName = function() {
        var room = RoomService.getRoom();
        return room ? room.name : '';
    };
    vm.getShowPasswordLabel = function() {
        /// Label for show password checkbox
        return gettextCatalog.getString('Show Password');
    };
    vm.getSubmitButtonLabel = function() {
        /// Label for OK button
        return gettextCatalog.getString('OK');
    };
    vm.hasLogo = function() {
        var logoUrl = ThemeService.getImageUrl('logo');
        return logoUrl !== null && logoUrl !== '';
    };
    vm.onKeyDown = function($event) {
        passwordError = false;
    };
    vm.onSubmitPassword = function() {
        var room = RoomService.getRoom();
        if (room === null) return;
        passwordError = false;
        vm.isProcessing = true;
        vm.showPassword = false;
        room.$loaded().then(function(room) {
            var promise = $q.resolve();
            if (vm.roomPassword === room.settings.userPassword) {
                var keyboard = sutl.getNode($window, 'cordova.plugins.Keyboard');
                if (keyboard !== null) {
                    keyboard.close();
                    promise = $timeout(300);
                }
                return promise.then(function() {
                    var passwordField = $document[0].getElementById('roomPassword');
                    if (passwordField) passwordField.blur();
                    RoomPasswordService.unlock(true);
                    delete vm.roomPassword;
                    if (!ViewStateService.getControlStateInitialized()) {
                        $state.go(ViewStateService.getCurrentState());                        
                    }
                });
            } else {
                passwordError = true;
                delete vm.roomPassword;
            }
            return promise;
        }).finally(function() {
            vm.isProcessing = false;
        });
    };
    vm.remoteControlCodeVisible = RemoteControlService.remoteControlCodeVisible;

    function onStateChange(event, toState, toParams, fromState, fromParams) {
        if (fromState.name === 'roomPassword' && toState.name !== 'roomPassword') {
            passwordError = false;
            vm.isProcessing = false;
            vm.showPassword = false;
            delete vm.roomPassword;
        }
    }
}

module.exports = RoomPasswordController;